<template>
        <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="deveMostrarModalMotivoJustificativa">
            <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="primary modal-title" primary-title>
                    <span>{{ titulo }}</span>
                    <v-btn flat depressed @click="processarCancelamento">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-layout class="d-flex pa-3" v-if="ilustracao.label1 || ilustracao.label2">
                  <v-flex xs12 v-if="ilustracao.label1">
                      <label><strong>{{ ilustracao.label1 }}</strong></label>
                      <p class="text--secondary">{{ ilustracao.texto1 }}</p>
                  </v-flex>
                  <v-flex xs12 v-if="ilustracao.label2">
                      <label><strong>{{ ilustracao.label2 }}</strong></label>
                      <p class="text--secondary">{{ ilustracao.texto2 }}</p>
                  </v-flex>
                </v-layout>

                <v-card-text class="pb-0 az-form-content mt-0">
                    <v-textarea v-model="motivoJustificativa"
                                :error-messages="errors.collect('Motivo/Justificativa')"
                                v-validate="'required'"
                                :key="'Motivo-Justificativa'"
                                name="Motivo/Justificativa"
                                label="Motivo/Justificativa"
                                placeholder="Digite aqui o motivo/justificativa"
                                rows="6"
                                maxlength="1000"
                                :counter="1000" class="py-3"/>
                </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn v-if="comBotaoCancelar" id="botaoCancelar" color="botao-cancelar-color" outline flat @click="processarCancelamento">
                        {{ textoBotaoCancelar }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="comBotaoConfirmar" id="botaoConfirmar" color="primary" depressed @click="processarConfirmacao">
                        {{ textoBotaoConfirmar}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'ModalEnviarMotivoJustificativa',
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        deveMostrarModalMotivoJustificativa: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 450
        },
        titulo: {
            type: String,
            default: 'Motivo/Justificativa'
        },
        ilustracao: {
            type: Object,
            default: () => ({
                label1: null,
                texto1: null,
                label2: null,
                texto2: null,
            })
        },
        comBotaoConfirmar: {
            type: Boolean,
            default: false
        },
        comBotaoCancelar: {
            type: Boolean,
            default: false
        },
        textoBotaoCancelar: {
            type: String,
            default: 'Cancelar'
        },
        textoBotaoConfirmar: {
            type: String,
            default: 'Confirmar'
        }
    },
    data(){
        return {
            motivoJustificativa: '',
            Modal
        }
    },
    methods: {
        async processarConfirmacao() {
            await this.validarPreenchimento()
            this.$emit('confirmar', this.motivoJustificativa)
            this.limparCampos()
        },
        async validarPreenchimento() {
            const estaValidado = await this.$validator.validate('Motivo/Justificativa')
            if (!estaValidado) {
                throw new Error('Preencha motivo/justificativa.')
            }
        },
        processarCancelamento() {
            this.$emit('cancelar')
            this.limparCampos()
        },
        limparCampos() {
            this.$validator.reset()
            this.motivoJustificativa = ''
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>